import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doDownload, doPostDownload } from './utils'

// const API_ROOT = 'http://localhost:80/api'

// ---------------------------------- 1.รายงานแบบขออนุมัติโครงการ
export const getApprovalform = () => {
  const url = `${API_ROOT}/files/criteria/approvalform`
  return doGet(url)
}

export const getApprovalFormReportSubmitPdf = (id) => {
  const url = `${API_ROOT}/files/download/${id}/approvalform`
  return doDownload(url)
}

// ----------------------------------

// ---------------------------------- 2.รายงานสรุปเพื่อขออนุมัติ
export const getSummarizeform = () => {
  const url = `${API_ROOT}/files/criteria/summarizeform`
  return doGet(url)
}

export const getSummarizeformFormReportSubmitPdf = (id) => {
  const url = `${API_ROOT}/files/download/${id}/summarizeform`
  return doDownload(url)
}

// ----------------------------------

// ---------------------------------- 3.สัญญารับทุน
export const getContractform = () => {
  const url = `${API_ROOT}/files/criteria/contractform`
  return doGet(url)
}

export const getContractFormReportSubmitPdf = (id) => {
  const url = `${API_ROOT}/files/download/${id}/contractform`
  return doDownload(url)
}

export const saveWitnessName = (request, projectVersionId) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/contract`
  return doPost(url, request)
}

// ----------------------------------

// ---------------------------------- 4.ใบเบิกเงิน
export const getBillpayment = () => {
  const url = `${API_ROOT}/files/criteria/billpayment`
  return doGet(url)
}

export const getBillpaymentFormReportSubmitPdf = (id, periodNo) => {
  const url = `${API_ROOT}/files/download/${id}/billpaymentform/${periodNo}`
  return doDownload(url)
}

export const getBillpaymentperiodFormReportSubmitPdf = (id, periodNo) => {
  const url = `${API_ROOT}/files/download/${id}/billpaymentperiodform/${periodNo}`
  return doDownload(url)
}

// ----------------------------------

// ---------------------------------- 5.ขออนุมัติปิดโครงกาารย่อย
export const getClosureform = () => {
  const url = `${API_ROOT}/files/criteria/closureform`
  return doGet(url)
}

export const getClosureFormReportSubmitPdf = (id) => {
  const url = `${API_ROOT}/files/download/${id}/closureform`
  return doDownload(url)
}

// ----------------------------------

// ---------------------------------- 6.แบบรายงานความก้าวหน้าโครงการ
export const getProgressiveform = () => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/files/criteria/progressiveform`
  return doGet(url)
}

// ## 6.1. รายงานความก้าวหน้าโครงการย่อยนำส่ง สสส.
export const getProgresstothaihealthFormReportSubmitPdf_Old = (id) => {
  const url = `${API_ROOT}/files/download/${id}/progresstothaihealthform`
  return doDownload(url)
}
export const getProgresstothaihealthFormReportSubmitPdf = (projectVersionId, reportDate) => {
  // /api/files/{projectVersionId}/{reportDate}/mod/progress/form
  const url = `${API_ROOT}/files/${projectVersionId}/${reportDate}/mod/progress/form`
  return doDownload(url)
}

// ## 6.2. แบบรายงานความก้าวหน้าโครงการย่อยนำส่ง ผู้จัดการแผนงาน/โครงการ
export const getProgresstomanagerFormReportSubmitPdf_Ole = (id) => {
  return false //ไม่ใช้เส้นนี้แล้ว
  const url = `${API_ROOT}/files/download/${id}/progresstomanagerform`
  return doDownload(url)
}

export const getProgresstomanagerFormReportSubmitPdf = (subProjectVersionId, reportDate) => {
  const url = `${API_ROOT}/files/${subProjectVersionId}/${reportDate}/progress/manager/form`
  return doDownload(url)
}

// ## 6.3. แบบรายงานความก้าวหน้าตามงวด
export const getProgressivebyperiodFormReportSubmitPdf = (id, periodNo) => {
  const url = `${API_ROOT}/files/download/${id}/progressivebyperiodform/${periodNo}`
  return doDownload(url)
}

// ----------------------------------

// ---------------------------------- 7. ทะเบียนควบคุมโครงการ

export const getRegisterControl = () => {
  const url = `${API_ROOT}/files/subproject/register-control/page`
  return doGet(url)
}

export const downloadRegisterControl = (id) => {
  const url = `${API_ROOT}/files/subproject/register-control/${id}/report`
  return doDownload(url)
}

// ----------------------------------

// ---------------------------------- 8. รายงานโครงการย่อย
export const getDetails = () => {
  const url = `${API_ROOT}/files/subproject/details/page`
  return doGet(url)
}

export const downloadDetails = (request) => {
  const url = `${API_ROOT}/files/subproject/details/report`
  // return doPost(url, request)
  return doPostDownload(url, request)
}
// ----------------------------------
